"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constantsClasses_1 = require("../data/constantsClasses");
var Datenschutz = /** @class */ (function () {
    function Datenschutz() {
        var path = location.pathname.toUpperCase();
        if (!path.includes('DATENSCHUTZ'))
            return;
        Datenschutz.elements = document.querySelectorAll(".".concat(constantsClasses_1.CLASS_MASK_TEXT));
        if (!Datenschutz.elements || !(Datenschutz.elements.length > 0))
            return;
        document.addEventListener('scroll', Datenschutz.removeFade);
        Datenschutz.removeMargin();
    }
    Datenschutz.removeMargin = function () {
        // for all except the last element
        for (var i = 0; i < Datenschutz.elements.length - 2; i++) {
            if (!Datenschutz.elements[i].classList.contains(constantsClasses_1.CLASS_MASK_TEXT_NO_MARGIN))
                Datenschutz.elements[i].classList.add(constantsClasses_1.CLASS_MASK_TEXT_NO_MARGIN);
        }
    };
    Datenschutz.removeFade = function () {
        for (var i = 0; i < Datenschutz.elements.length; i++) {
            if (Datenschutz.elements[i].classList.contains(constantsClasses_1.CLASS_FADABLE)) {
                Datenschutz.elements[i].classList.remove(constantsClasses_1.CLASS_FADABLE);
                return;
            }
            document.removeEventListener('scroll', Datenschutz.removeFade);
        }
    };
    return Datenschutz;
}());
exports.default = Datenschutz;
